const items = [
  {
    quote: "Went from admin support to a Salesforce Developer role in 7 months. The mock-interview drills made the difference on offer day.",
    name: "Priya S.",
    role: "Salesforce Developer, Bengaluru",
  },
  {
    quote: "The AWS SAA cohort was intense but pragmatic. Landed a Cloud Engineer role at a product company with a 60% salary bump.",
    name: "Madhu K.",
    role: "AWS Solutions Architect, Hyderabad",
  },
  {
    quote: "Career-switcher at 34, non-IT background. HCS taught MuleSoft from the ground up and my resume finally started getting shortlists.",
    name: "Arjun M.",
    role: "MuleSoft Developer, Pune",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials" className="mx-auto max-w-7xl px-6 lg:px-10 py-20 md:py-28 border-t border-slate-200">
      <div className="max-w-3xl">
        <div className="text-xs uppercase tracking-widerest text-slate-500 font-mono-plex">Alumni voices</div>
        <h2 className="mt-3 font-display font-bold tracking-tight text-3xl md:text-4xl text-slate-950">
          Real jobs. Real switches. Real numbers.
        </h2>
      </div>

      <div className="mt-12 grid md:grid-cols-3 gap-6">
        {items.map((t, i) => (
          <blockquote
            key={i}
            data-testid={`testimonial-${i}`}
            className="border border-slate-200 bg-white p-6 md:p-8 flex flex-col justify-between"
          >
            <p className="font-display text-lg md:text-xl text-slate-900 leading-snug tracking-tight">
              “{t.quote}”
            </p>
            <footer className="mt-8 pt-4 border-t border-slate-100">
              <div className="font-semibold text-slate-950 text-sm">{t.name}</div>
              <div className="text-xs text-slate-500 mt-0.5">{t.role}</div>
            </footer>
          </blockquote>
        ))}
      </div>
    </section>
  );
}
